export default __webpack_public_path__ + "static/media/logo-v2.8aa2f5f1.svg";